import { processData } from "@/mocks/homeData";

export default function ProcessSection() {
  return (
    <section id="process" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
            How We Work
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
            {processData.headline}
          </h2>
          <p className="text-foreground-700 leading-relaxed">
            {processData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-4 lg:gap-6">
          {processData.steps.map((step, index) => (
            <div key={step.number} className="relative">
              {index < processData.steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(100%-1rem)] w-[calc(100%-2rem)] h-px bg-primary-200" />
              )}
              <div className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 h-full">
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-heading font-bold text-2xl md:text-3xl text-primary-500">
                    {step.number}
                  </span>
                  <div className="flex-1 h-px bg-background-300/60" />
                </div>
                <h4 className="font-heading font-semibold text-lg md:text-xl text-foreground-950 mb-3">
                  {step.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}